// import router from 'vue-router'
import axios from 'axios';
import Vue from 'vue';
import { buildHourAppUserPayload, normalizeDepartmentNames } from '../../utils/userSync';

const actions = {

    getMyProfile: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        return axios.get(ApiClient.CLOUD_API + '/me/info', {
            headers: { Authorization: 'Bearer ' + ApiClient.token }
          }).then(res => {
           if(res.data.code == 'auth/id-token-expired'){
               localStorage.removeItem('firebaseToken')
               window.location.href = '/'
               return
           }
            if (res.status === 200) {
                var user = res.data.user;//checkUserRole(res.data.user)
                user.selectedDepartment = user.selectedDepartment && user.departments.length > 0 ? user.selectedDepartment :  user.departments[0].name;
                commit('setMe', user)
            }
            return {user: user, customToken: res.data.customToken}
          }).catch((err) => {
            return err
        });
    },
    getAllUsers: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(ApiClient.CLOUD_API + '/users/all', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
    getUser: ({commit}, ID, ApiClient) => {
        ApiClient.User.getUser(ID).then(res => {
            if (res.status === 200)
                return res
        }).catch((err) => {
            return err
        });

    },
    // HOUR APP ----------------------------------------------------------
    getMyUserHourApp: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/user', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            commit('setHourAppUser', res.data.data)
            return res
          }).catch((err) => {
            return err
        });
    },
    getFlexWorkersHourApp: ({commit}, payload) => {
        const { ApiClient, departments, department } = payload;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/flexworkers', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                    ...(department ? { department } : {}),
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    }, 
    postUserHourApp: ({commit},payload) => {
        const ApiClient = payload.ApiClient;
        const user = {
            ...payload.user,
            departments: normalizeDepartmentNames(payload.user && payload.user.departments),
            firebaseIdToken: ApiClient.token,
        }

        // Hands the response back whole, refusal and all, so the caller can tell one from the other
        // with `describeHourAppSyncOutcome`. Returning `res.data` on success and the error object on
        // failure made the two indistinguishable, which is why refused syncs were announced as
        // successful ones. Toasting from here is not an option either: a store action has no `this`
        // to reach `$toasted` through.
        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/user/register', {...user})
            .then(res => res)
            .catch(err => err)
    },
    recordPortalLogin: (context, payload) => {
        const ApiClient = payload.ApiClient;

        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/user/portal-login', {
            firebaseIdToken: ApiClient.token,
        }).then(res => res).catch(err => err);
    },
    // END HOUR APP ----------------------------------------------------------
    getUsersFromApi: ({commit}, ApiClient) => {
        ApiClient.User.getUsers().then(res => {
            if (res.status === 200) {
                commit('setUsers', res.data)
            }
        }).catch((err) => {
            return err
        });

    },
    postUser: ({commit},payload) => {
        var ApiClient = payload.ApiClient;

        return axios.post(ApiClient.CLOUD_API + '/users/new', {user: payload.user, firebaseIdToken: payload.ApiClient.token}).then(res => {
            if (res.status === 201) {
                return res.data
            }
            if (res.status === 400) {
                this.$toasted.global.failedRequest({message: res.data.message});
                return res.data
            }
            return res
        }).catch(err => {
            return err
        })
    },
    updateUser: ({commit},payload) => {
        var ApiClient = payload.ApiClient;

        return axios.post(ApiClient.CLOUD_API + '/users/edit', {user: payload.user, firebaseIdToken: payload.ApiClient.token}).then(res => {
            if (res.status === 201) {
                return res.data
            }
            if (res.status === 400) {
                this.$toasted.global.failedRequest({message: res.data.message});
                return res.data
            }
            return res
        }).catch(err => {
            return err
        })
    },
    deleteUser: ({commit},payload) => {
        var ApiClient = payload.ApiClient;

        return axios.post(ApiClient.CLOUD_API + '/users/delete', {user: payload.user, firebaseIdToken: payload.ApiClient.token}).then(res => {
            if (res.status === 201) {
                return res.data
            }
            if (res.status === 400) {
                this.$toasted.global.failedRequest({message: res.data.message});
                return res.data
            }
            return res
        }).catch(err => {
            return err
        })
    },
    putUser: ({commit, dispatch}, payload) => {
        var ApiClient = payload.ApiClient
        if (!payload.user.company_id) {
            payload.user.company_id = payload.user.company.id
        }
        return ApiClient.User.createUser(payload.user).then(res => {

            if (res.status === 201) {
                dispatch('getUsersFromApi', ApiClient)
                return res.data
            }
            if (res.status === 400) {
                this.$toasted.global.failedRequest({message: res.data.message});
                return res.data
            }
            return res

        }).catch(err => {

            return err
        })
    },
    setPassword: ({commit, dispatch}, payload) => {
        let ApiClient = payload.ApiClient
        return ApiClient.User.setPassword({password: payload.newPassword}).then((res) => {
            return res
        }).catch(() => {

        })
    },
    setUserToApp: ({commit}, payload) => {
        let ApiClient = payload.ApiClient
        let USER_ID = payload.user
        let app = payload.id
        // return true
        return ApiClient.User.setUserToApp(USER_ID, app).then(res => {
            if (res.status === 201) {
                return true
            } else {
                return false
            }
        }).catch(() => {
            // Vue.toasted.global.failedRequest({
            //     message : 'Something went wrong while fetching companies'
            // });
        });
    },
    removeUserFromApp: ({commit}, payload) => {
        let ApiClient = payload.ApiClient
        let USER_ID = payload.user
        let app = payload.app

        // return true
        return ApiClient.User.removeUserFromApp(USER_ID, app).then(res => {
            if (res.status === 200) {
                return true
            } else {
                return false
            }
        }).catch((e) => {
            return e
            // Vue.toasted.global.failedRequest({
            //     message : 'Something went wrong while fetching companies'
            // });
        });
    },
    getUserAvatar: ({commit}, payload) => {
        const ApiClient = Vue.prototype.$ApiClient;
        const params =  {
            firebaseIdToken: ApiClient.token
        }
        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/user/' + payload + '/profile-picture', {
            params,
            responseType: 'blob'
        }).then(function (res) {
            return res;
        }).catch(function (e) {
            return e;
        });
    },
}

export default actions

function checkUserRole(user) {

    if (user.type === "user") {
        user.user = true
    }
    if (user.type === "admin") {
        user.user = true, user.admin = true
    }
    if (user.type === "root") {
        user.user = true, user.admin = true, user.root = true
    }

    return user
}